import { type ComponentPropsWithoutRef } from 'react';
import { clsx } from 'clsx';
// eslint-disable-next-line no-restricted-imports
import NextLink from 'next/link';
import { getReferrer, getRelProperty } from 'utils/getRelProperty';
import styles from './Link.module.scss';

export type LinkProps = Omit<ComponentPropsWithoutRef<'a'>, 'rel'> & {
  readonly plainLink?: boolean;
  readonly noFollow?: boolean;
  readonly noScroll?: boolean;
  readonly rtlPlus?: boolean;
  readonly onClick?: () => void;
};

const Link = ({
  children,
  id,
  href = '',
  target,
  plainLink = false,
  noFollow,
  noScroll,
  className,
  onClick,
  ...props
}: LinkProps) => {
  if (onClick) {
    return (
      <button id={id} className={clsx(styles.button, className)} onClick={onClick}>
        {children}
      </button>
    );
  }
  const isRtlLink = getReferrer(href);

  if (plainLink) {
    return (
      <a
        id={id}
        className={className}
        href={href}
        target={target}
        rel={getRelProperty(noFollow, target, undefined, isRtlLink)}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <NextLink
      prefetch={false}
      rel={getRelProperty(noFollow, target, undefined, isRtlLink)}
      id={id}
      className={clsx(styles.link, className)}
      href={href}
      target={target}
      scroll={!noScroll}
      {...props}
    >
      {children}
    </NextLink>
  );
};

export default Link;
